import {
  AboutUs,
  PopularPrograms,
  Courses,
  Contacts,
  Socials,
  SummerTraining,
  Businesses,
} from "./FooterConstants";
import { NAV_LINK_CONSTANTS } from "../../Constants/NavLinksContants";

function Footer() {
  return (
    <div className="bg-[#181b43] py-[40px] md:px-[40px] sm:px-[30px] px-[20px] flex justify-center">
      <div className="flex md:flex-nowrap flex-wrap sm:justify-evenly md:justify-between lg:gap-[56px] md:gap-[56px] sm:gap-[20px] gap-[20px]">
        <div>
          <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
            About us
          </p>
          <div className="flex flex-col gap-[12px] mt-[12px]">
            {AboutUs.map((about) => (
              <a key={about.id} href={about.aboutLink}>
                <p className="cursor-pointer font-gilroy text-[#f8fafc] text-[14px] leading-[20px] tracking-wide">
                  {about.aboutTxt}
                </p>
              </a>
            ))}
          </div>
        </div>
        <div className="lg:w-[381px] md:w-[351px] sm:w-[330px] sm:order-none -order-[1] lg:order-none">
          <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
            Popular Programs
          </p>
          <div className="mt-[12px] flex flex-col gap-[12px]">
            {PopularPrograms.map((program) => (
              <a key={program.id} href={program.programLink}>
                <div className="cursor-pointer flex items-center gap-[12px]">
                  <div className="relative lg:w-[116px] w-[113px] shrink-0">
                    <img src={program.programImg} alt="program-img" />
                  </div>
                  <div className="lg:max-w-[250px]  ">
                    <h4 className="text-[#f8fafc] text-[14px] text-left leading-[20px] tracking-wide text-wrap font-gilroy-bold">
                      {program.programName}
                    </h4>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Flex-Column Containing More Courses, Summer Training, For Businesses */}

        <div className="flex flex-col gap-[32px]">
          <div>
            <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
              More Courses
            </p>
            <div className="mt-[12px] flex flex-col gap-[12px]">
              {Courses.map((course) => (
                <a key={course.id} href={course.courseLink}>
                  <h4 className="cursor-pointer font-gilroy text-[#f8fafc] text-[14px] leading-[20px] tracking-wide">
                    {course.courseName}
                  </h4>
                </a>
              ))}
            </div>
          </div>

          <div>
            <a
              href={`${NAV_LINK_CONSTANTS.AGENTIC_AI_PAGE_URL}`}
            >
              <div className="flex items-center gap-[10px]">
                <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
                  Become AI Engineer
                </p>
                <span className="bg-[#FCD34D] text-[#020617] text-[12px] px-[8px] rounded font-gilroy-medium">
                  New
                </span>
              </div>
              <div className="mt-[12px] flex flex-col gap-[20px]">
                {SummerTraining.map((course) => (
                  <h4
                    key={course.id}
                    className="cursor-pointer font-gilroy text-[#f8fafc] text-[14px] leading-[20px] tracking-wide"
                  >
                    {course.courseName}
                  </h4>
                ))}
              </div>
            </a>
          </div>

          <div>
            <a href={`${NAV_LINK_CONSTANTS.SUMMER_TRAINING_URL}`}>
              <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
                For Businesses
              </p>
              <div className="mt-[12px] flex flex-col gap-[20px]">
                {Businesses.map((course) => (
                  <h4
                    key={course.id}
                    className="cursor-pointer font-gilroy text-[#f8fafc] text-[14px] leading-[20px] tracking-wide"
                  >
                    {course.courseName}
                  </h4>
                ))}
              </div>
            </a>
          </div>
        </div>

        <div className="flex flex-col">
          <div>
            <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
              Contact Us
            </p>
            <div className="mt-[12px] flex flex-col gap-[12px] max-w-[271px]">
              {Contacts.map((contact) => (
                <div
                  key={contact.id}
                  className="cursor-pointer flex gap-[8px] items-center mt-2"
                >
                  <div
                    className={`w-[24px] -ml-2`}
                  >
                    <img
                      src={contact.contactIcon}
                      width={24}
                      alt="contact-icon"
                    />
                  </div>
                  <a href={contact.contactLink}>
                    <p className="font-gilroy text-[#f8fafc] text-[14px] leading-[20px] tracking-wide">
                      {contact.contactTxt}
                    </p>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-[32px]">
            <div>
              <p className="text-[#f8fafc] text-[16px] leading-[20px] tracking-wide uppercase font-gilroy-bold">
                Social Links
              </p>
              <div className="flex gap-[12px] mt-[12px]">
                {Socials.map((social) => (
                  <div key={social.id} className="cursor-pointer w-[40px]">
                    <a href={social.socialLink}>
                      <img src={social.socialIcon} alt="social-icon" />
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-[32px]">
              <p className="font-gilroy text-[#f8fafc] text-[14px] leading-[20px] tracking-wide">
                All Right Reserved with @Programming Pathshala
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
